import { Select, useMantineColorScheme } from "@mantine/core";
import { useEffect, useState } from "react";

type SellPriceLevelSelectProps = {
  value: number; // 1, 2, or 3
  onChange: (value: number) => void;

  label?: string;
  placeholder?: string;
  readonlyMode?: boolean;
  disabled?: boolean;
  styles?: React.CSSProperties;
};

const SellPriceLevelSelect: React.FC<SellPriceLevelSelectProps> = ({
  value,
  onChange,
  label = "Select",
  placeholder = "Select...",
  readonlyMode = false,
  disabled = false,
  styles,
  ...rest
}) => {
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const labelColor = isDark ? "#e0e0e0" : "#1a1a1a";

  // Local state as string ("1", "2", "3")
  const initial = String(value ?? 0);
  const [localValue, setLocalValue] = useState<string>(initial);

  // Sync when parent updates (e.g., form loads data)
  useEffect(() => {
    setLocalValue(String(value));
  }, [value]);

  const handleChange = (val: string | null) => {
    if (!val) return;

    setLocalValue(val);
    onChange(Number(val));
  };

  return (
    <Select
      label={label}
      placeholder={placeholder}
      data={[
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
      ]}
      value={localValue}
      title={`User Sellprice Level: ${value}`}
      onChange={handleChange}
      readOnly={readonlyMode}
      disabled={disabled}
      labelProps={{
        fw: 600,
        size: "lg",
        style: { color: labelColor },
      }}
      styles={{
        input: {
          backgroundColor: readonlyMode
            ? isDark
              ? "#2a2a2a"
              : "#f5f5f5"
            : isDark
              ? "#3a3a3a"
              : "white",

          borderColor: readonlyMode
            ? isDark
              ? "#555"
              : "#d0d0d0"
            : isDark
              ? "#4dabf7"
              : "#228be6",

          cursor: readonlyMode ? "default" : "pointer",
          transition: "background-color 120ms ease, border-color 120ms ease",
        },
        ...styles,
      }}
      {...rest}
    />
  );
};

export default SellPriceLevelSelect;
